/** @format */

export const JOYRIDE_DECKS: string = 'joyride-decks';
export const JOYRIDE_CARDS: string = 'joyride-cards';
export const JOYRIDE_STUDY: string = 'joyride-study';
